var _path, _path2, _path3, _line;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V6.5C1.5 6.77614 1.72386 7 2 7C2.27614 7 2.5 6.77614 2.5 6.5V2.5H6.5C6.77614 2.5 7 2.27614 7 2C7 1.72386 6.77614 1.5 6.5 1.5H2ZM9.64645 10.3536C9.84171 10.5488 10.1583 10.5488 10.3536 10.3536C10.5488 10.1583 10.5488 9.84171 10.3536 9.64645L9.64645 10.3536ZM1.64645 2.35355L9.64645 10.3536L10.3536 9.64645L2.35355 1.64645L1.64645 2.35355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.35L12.55 23.03C7.4 18.36 4 15.28 4 11.5C4 8.42 6.42 6 9.5 6C11.24 6 12.91 6.81 14 8.09C15.09 6.81 16.76 6 18.5 6C21.58 6 24 8.42 24 11.5C24 15.28 20.6 18.36 15.45 23.04L14 24.35Z",
    fill: "#D2595A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.35L16.55 27.03C11.4 22.36 8 19.28 8 15.5C8 12.42 10.42 10 13.5 10C15.24 10 16.91 10.81 18 12.09C19.09 10.81 20.76 10 22.5 10C25.58 10 28 12.42 28 15.5C28 19.28 24.6 22.36 19.45 27.04L18 28.35Z",
    fill: "#E59E9E"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.7065,
    y1: 18.9717,
    x2: 29.9717,
    y2: 30.2935,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor2);
export default __webpack_public_path__ + "static/media/cursor-2.c8b1eaf18dc46ae5fbadea30cd55d615.svg";
export { ForwardRef as ReactComponent };